module.exports = __webpack_public_path__ + "static/use-case-3-content-2-32380b47112f0830452eff92a861ce0f.png";